import {createRouter, createWebHistory} from 'vue-router';
import LoginPage from '../views/LoginPage.vue';
import SignUpPage from '../views/SignUpPage.vue';
import VerifyEmailPage from '../views/VerifyEmailPage.vue';
import FeedSetup from "@/views/FeedSetup.vue";
import FeedsPage from "@/views/FeedsPage.vue";
import FeedDetail from "@/views/FeedDetail.vue";
import UserSettings from "@/views/UserSettings.vue";
import NotFound from "@/views/NotFound.vue";
import store from "@/store";
//import HomePage from "@/views/HomePage.vue";


const routes = [
    {path: '/', redirect: '/feeds'},
    /*
        {path: '/home', name: 'home', component: HomePage},
    */
    {path: '/login', name: 'login', component: LoginPage},
    {path: '/signup', name: 'sign-up', component: SignUpPage},
    {path: '/verify-email', name: 'verify-email', component: VerifyEmailPage},
    {path: '/feed/setup', name: 'feed-setup', component: FeedSetup, meta: {'requiresAuth': true}},
    {path: '/feeds', name: 'feeds', component: FeedsPage, meta: {'requiresAuth': true}},
    {
        path: '/feeds/:id(\\\\d+|[0-9a-fA-F-]{36})',
        name: 'feed-detail',
        component: FeedDetail,
        meta: {'requiresAuth': true}
    },
    {path: '/user-settings', name: 'user-settings', component: UserSettings, meta: {'requiresAuth': true}},
    {path: '/:pathMatch(.*)*', name: 'not-found', component: NotFound}
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
});

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!store.getters.isAuthenticated) {
            next('/login');
        } else {
            next();
        }
    } else {
        next();
    }
});

export default router;
